import React from 'react'
import styles from './index.module.scss'

interface RadioProps{
    isOn: boolean,
    changeState: (newState: boolean) => void
}
export default function Radio({changeState, isOn }: RadioProps){

    return (
        <div className={`${styles.radio} ${isOn && styles.on}`} onClick={() => changeState(!isOn)}>
            <div className={styles.radio__circle}/>
        </div>
    )
}
